function firstQueryValue(value) {
  return Array.isArray(value) ? value[0] : value
}

function isAuthPath(path) {
  return /^\/(?:login|signup|sign-up)(?:[/?#]|$)/.test(path)
}

export function safeRedirectPath(redirectPath = '', fallback = '/home') {
  const target = String(firstQueryValue(redirectPath) || '').trim()
  if (
    !target ||
    !target.startsWith('/') ||
    target.startsWith('//') ||
    target.includes('\\') ||
    isAuthPath(target)
  ) {
    return fallback
  }
  return target
}

export function buildLoginPath(redirectPath = '') {
  const target = safeRedirectPath(redirectPath, '')
  if (!target) {
    return '/login'
  }
  return `/login?redirect=${encodeURIComponent(target)}`
}

export function buildGoogleLoginPath(redirectPath = '') {
  const target = safeRedirectPath(redirectPath, '/home')
  const completePath = `/auth/google/complete?redirect=${encodeURIComponent(target)}`
  return `/api/v1/auth/google/login?next=${encodeURIComponent(completePath)}`
}
